import { Alert, Box, useMediaQuery } from "@mui/material";
import TextInputField from "../../../../../utils/Fields/TextInputField";
import { useEffect, useRef, useState } from "react";
import { Dropdown, TextArea } from "pepsico-ds";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import { getAPI } from "../../../../../API/ApiService";
import { BASE_URL } from "../../../../../constant/apiUrl";
import "./PageDetails.css";
import {
  isDuplicatePageTitle,
  isDuplicateNameInNavigations,
  stremaLineUrl,
} from "./dragUtils";
const PageDetails = ({
  setDescription,
  setDuplicate,
  duplicate,
  description,
  title,
  setTitle,
  setPageGroup,
  pageGroup,
  id,
  navigationId: navigationIdProp,
}) => {
  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext(); // ✅ using shared form context

  const isMobile = useMediaQuery("(max-width:600px)");

  const { internalGroups, navigations } = useSelector((store) => store.nav);

  const [existingPages, setExistingPages] = useState([]);
  const fetched = useRef();
  const onFieldChange = (field, value) => {
    setValue(field, value, { shouldValidate: true }); // ✅ triggers validation
  };

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const response = await getAPI(`${BASE_URL}/admin/order/hierarchy`);
        if (response?.status === 200) {
          const nav = stremaLineUrl(response?.data);

          setExistingPages(nav || []);
        }
      } catch (err) {
        console.error("Failed to fetch internal pages:", err);
      }
    };
    if (!fetched.current) {
      fetched.current = true;
      fetchInfo();
    }
  }, []);
  useEffect(() => {
    const duplicateInPages = isDuplicatePageTitle(title, existingPages, id);
    // Use navigationId from props (set by CreatePageBuilderLayout when editing)
    // This ensures we correctly exclude the current navigation item from duplicate check
    const navigationId = navigationIdProp || null;
    const duplicateInNavigations = isDuplicateNameInNavigations(
      title,
      navigations,
      navigationId
    );
    setDuplicate(duplicateInPages || duplicateInNavigations);
  }, [title, existingPages, navigations, id, navigationIdProp, setDuplicate]);

  return (
    <div className="flex flex-col gap-4">
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? "16px" : "48px",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: "400px" }}>
          <TextInputField
            required
            name="title"
            label="Page title"
            errors={errors}
            register={register}
            isMobile={isMobile}
            value={title}
            width="100%"
            onChange={(e) => {
              setTitle(e.target.value);
              onFieldChange("title", e.target.value);
            }}
            datatestid="text-input-keyword"
          />
          {duplicate && (
            <Alert severity="error" sx={{ mt: 1, maxWidth: "350px" }}>
              Page title already exists
            </Alert>
          )}
        </Box>

        <Box sx={{ width: "100%", maxWidth: "400px" }}>
          <Dropdown
            name="groupId"
            placeholder="Select"
            label="Page grouping"
            selection="single"
            className={`form-dropdown ${errors.countryId ? "error-label" : ""}`}
            error={errors.countryId}
            isClearable={true}
            selectedValue={pageGroup}
            style={{ fontSize: "14px", width: "100%" }}
            setSelectedValue={(value) => {
              setPageGroup(value);
              onFieldChange("groupId", value); // ✅ updates shared form
            }}
            childList={internalGroups?.map((item) => ({
              id: item.navigationId,
              displayText: item.label,
            }))}
          />
        </Box>
      </Box>
      <TextArea
        className="page-text"
        name="description"
        showToolbar={false}
        placeholder="Type here"
        label="Description"
        onChange={(e) => setDescription(e.target.value)}
        style={{ width: isMobile ? "100%" : "400px" }}
        value={description}
      />
    </div>
  );
};

export default PageDetails;
